import React from 'react';
import utils from 'utils';
import { useForm } from 'form';
import { Button, ErrorMessage } from 'components';
import { fb, validators } from 'form';

export function VariantAttributeEdit({ attr, onSave, onCancel }) {
  const isEdit = attr && attr.id;
  const model = getEditModel(attr || {});
  const form = useForm(model, {});

  const render = (name) => form.renderControl(name);

  function save(e) {
    form.validateForm(e, () => {
      const value = { ...form.getValue(), options: [] };
      onSave(value)
    })
  }

  return (
    <div className="editor" style={{ margin: '20px 0', padding: '15px', background: '#fffad9' }}>
      <h3>{isEdit ? 'Edit' : 'Add'} Attribute</h3>

      <section>
        <div className="row">
          <div className="col-md-9">{render('name')}</div>
        </div>
        <div className="row">
          <div className="col-md-9">{render('displayName')}</div>
        </div>
        <div className="row">
          <div className="col-md-9">{render('required')}</div>
        </div>
        <div className="row">
          <div className="col-12 actions">
            <ErrorMessage errors={form.errors} />
            <Button className="btn-sm" onClick={save} status={form.status}>{isEdit ? 'Update' : 'Create'}</Button>
            <Button className="btn-sm" onClick={onCancel} btnStyle="outline-dark">Cancel</Button>
          </div>
        </div>
      </section>
    </div>
  );
}

function getEditModel(data) {

  const model = fb.group({
    id: [data.id || utils.random.shortId(), { type: 'hidden' }],
    name: [data.name || '', [validators.Required()], { type: 'text', helpText: 'e.g., Colour, Size' }],
    displayName: [data.displayName || '', [], { type: 'text', helpText: 'If empty, Name will be used for Display Name' }],
    required: [typeof data.required === 'undefined' ? true : data.required, [], { type: 'checkbox' }],
  })

  return model;
}
